( function ($) {

  const $chat = $( '#telus-chat' );
  const $frame = $( 'iframe', $chat );
  const $toggle = $( '.toggle', $chat );
  const $close = $( '.close', $chat );
  const $backdrop = $( `<div id='telus-chat-backdrop'></div>` );
  $backdrop.insertAfter( $chat );
  const $vis = $frame.add( $close ).add( $backdrop );

  const speed = 300;

  let vis_debounce;
  function toggle () {
    clearTimeout( vis_debounce );
    const opening = !$chat.hasClass( 'open' );
    if ( opening ) {
      $vis.addClass( 'visible' );
    } else {
      vis_debounce = setTimeout( () => { $vis.removeClass( 'visible' ) }, speed );
    }
    $toggle.toggleClass( 'btn-primary', !opening ).toggleClass( 'btn-secondary', opening );
    $chat.toggleClass( 'open', opening );
  }

  $toggle.on( 'click', toggle );
  $close.on( 'click', function () {
    $chat.addClass( 'dismissed' );
    setTimeout( () => { $chat.add( $backdrop ).remove() }, speed );
    ThemeJS.Cookies.set({
      'chat-dismissed': 'true'
    });
  });

})( jQuery );